module.exports = __webpack_public_path__ + "assets/success.15458a06.svg";